'use strict';
(function (window, document, $) {
    let expertsNumber = $('.jwsdw-guuru-benefits').attr('data-total-experts'),
        averageRating = $('.jwsdw-guuru-benefits').attr('data-average-rating'),
        $guuruUpdateRating = $('.jwsdw-guuru-benefits-update-rating'),
        $guuruUpdateExperts = $('.jwsdw-guuru-benefits-update-experts');

    if ($guuruUpdateExperts.length) {
        const expertsText = $guuruUpdateExperts.text();
        const expertsUpdatedText = expertsText.replace(/\d+/, expertsNumber);
        $guuruUpdateExperts.text(expertsUpdatedText);
    }

    if ($guuruUpdateRating.length) {
        const ratingText = $guuruUpdateExperts.text();
        const ratinguUpdatedText = ratingText.replace(/\d+/, averageRating);
        $guuruUpdateRating.text(ratinguUpdatedText);
    }
}(window, document, jQuery));
